import { useMutation, UseMutationOptions, UseMutationResult } from 'react-query';
import { FieldValues, UseFormSetError } from 'react-hook-form';

export function useFormMutation<TData, TError, TVariables, TFormValues extends FieldValues>(
    mutationFn: (variables: TVariables) => Promise<TData>,
    setError?: UseFormSetError<TFormValues>,
    options?: UseMutationOptions<TData, TError, TVariables>
): UseMutationResult<TData, TError, TVariables> {
    return useMutation<TData, TError, TVariables>(mutationFn, {
        ...options,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onError: (error: any, v, c) => {
            if (setError) {
                // Check if the error response contains a validation errors array.
                const apiErrors = error.response?.data?.errors;
                if (apiErrors && Array.isArray(apiErrors)) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    apiErrors.forEach((err: any) => {
                        if (err.source?.parameter) {
                            setError(err.source.parameter, {
                                type: 'server',
                                message: err.detail,
                            });
                        }
                    });
                }
            }
            if (options?.onError) {
                options.onError(error, v, c);
            }
        },
    });
}
